<template>

  <template v-for="field in fields" :key="field.uuid">
    <ion-item :disabled="disabled" :class="field.rules && field.rules.length > 0 ? 'mr-7' : null" lines="inset">
      <ion-label :position="field.type != 'boolean' ? 'stacked' : null">
        {{ field.label }} <small v-if="field.rules && field.rules.length > 0 && !field.manual_override">
          (automatisch berekend)
        </small>
      </ion-label>
      <!-- field.rules && field.rules.length > 0 -->
      <template v-if="field.rules && field.rules.length == 0 || field.manual_override === true">
        <ion-input v-if="field.type == 'text'" v-model="field.value"
          :placeholder="field.placeholder ? field.placeholder : 'Vul waarde in'"></ion-input>

        <template v-else-if="field.type == 'float'">
          <ion-input inputmode="tel" type="tel" v-model="field.value"
            :placeholder="field.placeholder ? field.placeholder : 'Vul waarde in'"></ion-input>
        </template>

        <template v-else-if="field.type == 'date'">
          <ion-datetime-button presentation="date" datetime="datetime"></ion-datetime-button>

          <ion-modal :keep-contents-mounted="true">
            <ion-datetime presentation="date" :value="field.value" id="datetime" showDefaultButtons
              @ionInput="field.value = $event.detail.value" cancelText="Annuleren" doneText="Bevestigen"></ion-datetime>
          </ion-modal>
        </template>

        <template v-else-if="field.type == 'boolean'">
          <ion-toggle slot="end" v-model="field.value" :binary="true" />
        </template>

        <template v-else-if="field.type == 'select'">
          <ion-select mode="ios" okText="Kies" cancelText="Annuleren" v-model="field.value"
            :placeholder="field.placeholder ? field.placeholder : 'Kies waarde'">
            <ion-select-option :value="option.value" v-for="(option, index) in field.options" :key="index">
              {{ option.label }}</ion-select-option>
          </ion-select>
        </template>
      </template>

      <div class="small-meas-badge" v-else-if="field.manual_override == false">
        {{ field.value ? parsed(field.value) : 'Nog niet berekend' }}
      </div>


    </ion-item>
    <div slot="slot" class="manual-mode-button" v-ripple v-if="field.rules && field.rules.length > 0"
      @click.stop="setManualOverride(field)">
      <mdicon name="pencil" v-if="!field.manual_override" />
      <mdicon name="pencil-off" v-else />
    </div>

  </template>

</template>

<script>
import { db } from '@/services/db.js'
import measurement_calculator from '@/services/measurement_calculator.js'

export default {
  name: "component-attributes",
  props: ["rules", "disabled", 'component_uuid', 'no_list'],
  components: {

  },
  data() {
    return {
      fields: [],
    };
  },
  emits: ["updateFields"],
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      // components
      if (!this.component_uuid) return;
      const component = await db.base_components.where({ uuid: this.component_uuid }).first();

      this.fields = component?.attributes.fields;

      if(!this.fields){
        this.fields = [];
      }

      // set this.fields value from this.rules.fields value
      // check if fields is there and it is array
      if (this.rules.fields && Array.isArray(this.rules.fields)) {
        this.fields.forEach(field => {
          const rule = this.rules.fields.find(rule => rule.uuid == field.uuid);
          if (rule) {
            field.value = rule.value;
            field.manual_override = rule.manual_override;
          }
        });
      }
    },
    setManualOverride(field) {
      field.manual_override = !field.manual_override;
      this.$toast.success(field.manual_override ? "Handmatig invoeren" : "Automatisch berekend")
    },
    parsed(value) {
      if (value == null) return null;
      if (typeof value == "string") return value;
      if (typeof value == "number") {
        return this.formatNumber(value, 2);
      }
      return value;
    },
    formatNumber(value, decimals) {
      const parts = value.toFixed(decimals).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      parts[1] = parts[1].replace(".", ",");
      return parts.join(",");
    },
    emitCleanFields() {
      let fields = [...this.fields]

      measurement_calculator.field_rules

      this.$emit("updateFields", fields);
    }
  },
  watch: {
    fields: {
      handler() {
        this.emitCleanFields();
      },
      deep: true
    }
  }
};
</script>
